/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Icon = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M5.2602 34.6398C4.9302 34.9698 4.9302 35.5298 5.2602 35.8598L8.1302 38.7098C8.3002 38.8898 8.53019 38.9698 8.7502 38.9698C8.9702 38.9698 9.1902 38.8898 9.3502 38.7098L10.8902 37.1798L6.8002 33.0898L5.2602 34.6298V34.6398Z"
      fill="#000"
    />
    <path d="M23.1212 16.7873L16.7773 23.1289L20.8637 27.2167L27.2076 20.8751L23.1212 16.7873Z" fill="#000" />
    <path
      d="M38.7196 9.34953C39.0496 8.99953 39.0496 8.45953 38.7196 8.12953L35.8496 5.25953C35.6796 5.08953 35.4596 5.01953 35.2496 5.01953C35.0396 5.01953 34.7996 5.09953 34.6296 5.25953L33.0996 6.79953L37.1696 10.8795L38.7096 9.34953H38.7196Z"
      fill="#000"
    />
    <path
      d="M6.81957 24.9404L4.25957 27.5004C3.90957 27.8304 3.90957 28.3904 4.25957 28.7204L6.81957 31.2804L7.26957 31.7404L12.2596 36.7304L12.7096 37.1804L15.2696 39.7404C15.4396 39.9104 15.6696 40.0004 15.8896 40.0004C16.1096 40.0004 16.3296 39.9104 16.4896 39.7404L19.0596 37.1804L14.9896 33.1004L6.82957 24.9404H6.81957Z"
      fill="#000"
    />
    <path
      d="M20.8702 29.0295L20.4202 28.5795L15.4202 23.5795L14.9702 23.1195L10.3702 18.5295C10.2002 18.3595 9.98023 18.2695 9.77023 18.2695C9.56023 18.2695 9.32023 18.3595 9.17023 18.5295L6.30023 21.3795C5.97023 21.7095 5.97023 22.2695 6.30023 22.5995L6.83023 23.1295L7.28023 23.5795L7.73023 24.0295L11.8202 28.1095L15.8902 32.1995L19.9602 36.2795L20.4202 36.7395L20.8702 37.1895L21.3802 37.6995C21.5502 37.8695 21.7802 37.9595 22.0002 37.9595C22.2202 37.9595 22.4402 37.8695 22.6002 37.6995L25.4702 34.8495C25.7902 34.4995 25.7902 33.9595 25.4702 33.6295L20.8702 29.0395V29.0295Z"
      fill="#000"
    />
    <path
      d="M39.7404 15.26L37.1804 12.7L36.7304 12.25L31.7404 7.26L31.2904 6.81L28.7204 4.24C28.5504 4.07 28.3304 4 28.1204 4C27.9104 4 27.6704 4.08 27.5004 4.24L24.9404 6.8L29.0104 10.88L37.1704 19.04L39.7304 16.48C40.0804 16.15 40.0804 15.59 39.7304 15.26H39.7404Z"
      fill="#000"
    />
    <path
      d="M37.1798 20.8695L36.7298 20.4195L36.2698 19.9595L32.1998 15.8795L28.1298 11.7895L24.0398 7.70953L23.5898 7.25953L23.1398 6.80953L22.6098 6.27953C22.4398 6.10953 22.2198 6.01953 22.0098 6.01953C21.7998 6.01953 21.5598 6.10953 21.3898 6.27953L18.5398 9.12953C18.1898 9.45953 18.1898 10.0195 18.5398 10.3495L23.1398 14.9495L23.5898 15.3995L28.5898 20.3995L29.0398 20.8495L33.6298 25.4395C33.7998 25.6095 34.0298 25.6995 34.2498 25.6995C34.4698 25.6995 34.6898 25.6095 34.8498 25.4395L37.6998 22.5895C38.0298 22.2595 38.0298 21.6995 37.6998 21.3695L37.1898 20.8595L37.1798 20.8695Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default Icon
